import { parseQueryErrors } from '@zenbusiness/application-commons-graphql';

export const AUTH_ERROR_CODES = ['UNAUTHENTICATED', 'FORBIDDEN', 'AUTH_EXCEPTION'];

export default function globalGraphQLErrorHandler({ result }) {
  // Format graphQL errors into a more readable format
  // Code and path will be used to display a proper error message by the NotificationManager
  const errors =
    result?.error?.graphQLErrors?.map?.(
      ({ message, extensions: { code, errorCode } = {}, path = [] } = {}) => ({
        code: code || errorCode,
        message,
        path
      })
    ) || [];

  if (!errors.length) {
    return;
  }

  const authError = errors.find(({ code }) => AUTH_ERROR_CODES.includes(code));

  // Force re-login if someone provides a bad UUID or gets a permission failure
  const invalidRequestError = errors.find(
    ({ code, message }) =>
      (code === 'FORBIDDEN' && message === 'Permission failure') ||
      (code === 'BAD_USER_INPUT' && message.includes('UUID cannot represent non-UUID'))
  );

  /* if the user is trying to access a resource that returns 403 take them
        to the "home" page of the dashboard.
    */
  if (authError || invalidRequestError) {
    const { pathname } = window.location;
    if (!pathname || !pathname.startsWith('/d/logout')) {
      window.location.assign(`/d/logout?redirectTo=${pathname}`);
      return;
    }
  }

  // We don't need to throw these modified errors if they are order errors
  // They are handled by the Payment components
  const isOrderError = errors.some(({ path }) => path.includes('convertCartToOrder'));
  if (isOrderError) {
    return;
  }

  // Throw the errors so they can be caught and handled by the NotificationManager
  // we need to re-instantiate the Error so they can be sent to Sentry correctly
  const parsedErrors = parseQueryErrors({ graphQLErrors: result.error.graphQLErrors });
  throw parsedErrors;
}
